'use client'

import type { PropsWithChildren } from 'react'

export const DialogModalHeaderBanner = ({ children }: PropsWithChildren) => {
  return <div>{children}</div>
}
